 export interface IAuthentication {
    username: string;
    password: string;
    grant_type: string;
    client_id: string;
    client_secret: string;
    refresh_token?: string;
    tfa_key?: string;
    save_browser?: boolean;
    new_password?: string;
    new_password_confirm?: string;
}
